import React, { useEffect } from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import * as Styles from './_confirmUpdateBranchesStatusModal.module.scss';

const ConfirmUpdateAPIKeyModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.setting.modals.regenerateSilverAPIKeyModalIsOpen);
    const isLoading = useAppSelector(state => state.setting.loadings.updateSilverApiKeySettings);
    const error = useAppSelector(state => state.setting.errors.updateSilverApiKeySettings);

    const handleOnModalClose = () => dispatch(combinedActions.settingSetRegenerateSilverAPIKeyModalIsOpen(false));
    const handleSubmitClick = () => dispatch(combinedActions.settingUpdateSilverAPIKeySettingsAttempt());

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={'Confirm Regenerate API Key?'}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    label={'Confirm'}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={Styles['confirm-approve']}
                    disabled={isLoading}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmUpdateAPIKeyModal;
